export default "__VITE_ASSET__Dg_QXt6P__"